import { render, staticRenderFns } from "./FilterPublicProductCategories.vue?vue&type=template&id=478dc61a&"
import script from "./FilterPublicProductCategories.vue?vue&type=script&lang=js&"
export * from "./FilterPublicProductCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports